<div class="padding-wrapper">
  <div class="wrapper">
    <h1 class="margin-bottom">{{ 'profile.title' | translate }}</h1>

    <div class="header" *ngIf="profile">
      <div class="column gap center-children-vertically">
        <app-profile-icon [color]="getProfileInitialColorByRole()" [reload]="reload$" [editable]="true"
                          title="Modifier votre photo de profil" [big]="true" [profile]="profile"></app-profile-icon>
        <app-upload-file image link (updateFile)="updateImage($event)" >{{ 'profile.changePhoto' | translate }}</app-upload-file>
      </div>
      <div class="user-description">
        <div class="row gap">

          <h2 class="cooper">{{ capitalize(profile.firstName) }} {{ capitalize(profile.lastName) }}</h2>
          <app-icon button (click)="modifyNames()"
                    type="edit"></app-icon>
        </div>
        <p class="row gap center-children-vertically  text-bold">
          <app-icon type="email"/>
          {{profile.email}}</p>
        <p class="row gap center-children-vertically text-bold">
          <app-icon type="phone"/>
          {{profile.phoneNumber ?? ('profile.noPhone' | translate)}}
          <app-icon button (click)="modifyPhone()"
                    type="edit"></app-icon>
        </p>
        <p class="row gap center-children-vertically">{{ 'profile.password' | translate }} : <span class="text-bold">********</span>
          <app-icon button (click)="modifyPassword()"
                    type="edit"></app-icon>
        </p>
        <p class="row gap center-children-vertically">{{ 'profile.gender' | translate }} : <span class=" text-bold">{{ ('profile.genders.' + genderKey) | translate }}</span> <app-icon button (click)="modifyGender()"
                                        type="edit"></app-icon></p>
        <p class="row gap center-children-vertically">
          {{ 'profile.language' | translate }} :
          <select
            class="lang-select text-bold"
            [ngModel]="selectedLangId"
            (ngModelChange)="modifyLanguage($event)">
            <option
              *ngFor="let lang of availableLangs"
              [value]="lang.id"
              [disabled]="!isUiLangEnabled(lang.name)">
              {{ getLangLabel(lang.name) }}
            </option>
          </select>
        </p>
        <p *ngIf="organization">{{ 'profile.organization' | translate }}
          : <span class=" text-bold">{{organization}}</span></p>
        <p>{{ 'profile.role' | translate }} : <span class=" text-bold">{{role}}</span></p>
        <app-button [outline]="true" *ngxPermissionsOnly="'pilot'" (click)="switchProfile()">
          {{ 'profile.switchAccount' | translate }}
        </app-button>
      </div>
      <div>
        <div class="center-children" *ngIf="isSherpa">
          <app-button [outline]="true" (click)="modifyTimeSlotPreferences()" type="button" title="Mes dispos">{{ 'profile.availability' | translate }}
          </app-button>
        </div>
      </div>
    </div>
    <div class="margin-top-xl" *ngIf="isSherpa">
      <h2 class="margin-bottom">{{ 'profile.presentation' | translate }}</h2>
      <ng-template #noVideoLink>
        <div class="presenting-wrapper">
          <div class="video-thumbnail-container margin-bottom" *ngIf="!!profile.personalInformation.presentingVideoLink; else noLink">
            <app-image [src]="videoThumbnail" alt="Sherpa video thumbnail"></app-image>
            <app-button [icon]="'trash'" class="margin-top center-children-horizontally" [outline]="true" (click)="deletePresentingVideo()" type="button" title="Mes dispos">
              {{ 'profile.delete' | translate }}
            </app-button>
          </div>
        </div>
        <ng-template #noLink>
          <app-button [outline]="true" (click)="showAddVideo()" type="button" title="Ajout d'une vidéo"> {{ 'profile.addVideo' | translate }} </app-button>
          <br/>
        </ng-template>
      </ng-template>
      <ng-container *ngIf="showAddVideoLink; else noVideoLink">
        <form [formGroup]="videoLinkForm" (submit)="validate()">
          <h6>{{ 'profile.link' | translate }} :</h6>
          <div class="row gap margin-top-sm full-width">
            <app-input class="input-video-link" [error]="formError" [error-message]="errorMessage"  formControlName="link" type="link" placeholder="https://youtu.be/Ouf9bjNTD"/>
            <app-button class="confirm-button" type="submit" title="Saisie de ma présentation"> {{ 'profile.confirm' | translate }} </app-button>
          </div>
        </form>
      </ng-container>
      
      <ng-container *ngIf="!!profile.personalInformation.description && !editingDescription; else noPresentingText">
        <div class="presenting-text-container">
          <div class="rich-content-container" [innerHTML]="sanitizeHtml(profile.personalInformation.description)"></div>
          <div class="row modify-icon">
            <app-icon button title="Modifier" (click)="modifyDescription()" type="edit"></app-icon>
            <app-icon button title="Supprimer" (click)="deleteDescription()" type="trash"></app-icon>
          </div>
        </div>
      </ng-container>
      <br/>
      <div class="margin-top-xl">
          <ng-template #noPresentingText>
            <app-button *ngIf="!editingDescription && !addingDescription" (click)="addDescription()" type="button" title="Saisie de ma présentation"> {{ 'profile.enterPresentation' | translate }} </app-button>
            <div class="margin-top" *ngIf="addingDescription">
              <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [toolbar]="toolbar" [editor]="editor"> </ngx-editor-menu>
                <ngx-editor [editor]="editor" [ngModel]="description" (ngModelChange)="onDescriptionChange($event)" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
              </div>
              <div class="row gap presenting-text-action-button margin-top">
                <app-button title="Enregistrer"
                          (click)="updateDescription()"
                >{{ 'profile.save' | translate }}</app-button> 
                <app-button [outline]="true" title="Enregistrer"
                          (click)="cancelDescriptionEdit()"
                >{{ 'profile.cancel' | translate }}</app-button>  
            </div>    
            </div>
          </ng-template>
      
      <div class="margin-top" *ngIf="editingDescription">
        <div class="NgxEditor__Wrapper">
          <ngx-editor-menu [toolbar]="toolbar" [editor]="editor"> </ngx-editor-menu>
          <ngx-editor [editor]="editor" [ngModel]="description" (ngModelChange)="onDescriptionChange($event)" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
        </div>
        <div class="row gap presenting-text-action-button margin-top">
          <app-button title="Enregistrer"
                    (click)="updateDescription()"
          >{{ 'profile.save' | translate }}</app-button> 
          <app-button [outline]="true" title="Enregistrer"
                    (click)="cancelDescriptionEdit()"
          >{{ 'profile.cancel' | translate }}</app-button>  
        </div>    
      </div>
       
    </div>

    <div class="row center-children-horizontally">
      <a class="margin-top-xl" (click)="deleteAccount()" type="button" title="Supprimer mon compte">{{ 'profile.deleteAccount' | translate }}</a>
    </div>


  </div>

  <div class="full-screen mask center-children" *ngIf="loading">
    <app-spinner></app-spinner>
  </div>
</div>
